 <template>
    <Header/>
    <HeroSlider/>
    <CategoryArea/>
<!--    <BannerArea/>-->
    <Course/>
    <Blog/>
    <Events/>
    

<!--    <Pricing/>-->
    <InstructorArea/>
    <Question/>
    <BrandArea />
    <Footer footerPadding="true"/>
 </template>

 <script>
import Header from '../components/Home/Header.vue';
import CategoryArea from '../components/Home/CategoryArea.vue';
// import BannerArea from '../components/Home/BannerArea.vue';
import Course from '../components/Home/Course.vue';
import Events from '../components/Home/Events.vue';
import Question from '../components/Home/Question.vue';
// import Pricing from '../components/Home/Pricing.vue';
import InstructorArea from "@/components/Instructor/InstructorArea.vue";
import Footer from '../components/Home/Footer.vue';
import HeroSlider from "@/components/HomeThree/HeroSlider.vue";
import Blog from "@/components/HomeTwo/Blog.vue";
import BrandArea from "@/components/common/BrandArea.vue";

 export default {
     name:'HomePage',
     components:{
         HeroSlider,
         Header,
         CategoryArea,
         // BannerArea,
         Course,
         Events,
         Question,
         // Pricing,
         InstructorArea,
         BrandArea,
         Blog,
         Footer,
     }
 }
 </script>
